import React, { useEffect, useState, useRef } from 'react';
import styles from '../assets/css/gapsy-navbar.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { useChatbot } from "../components/ChatbotContext";

import { Chart, PieController, ArcElement, Tooltip, Legend, Title, BarController, BarElement, CategoryScale, LinearScale, DoughnutController } from 'chart.js';
import axios from 'axios';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import autoTable from 'jspdf-autotable';
import { UploadLoadingIcon } from "../components/Propertyfile";

import { generatereport, Audit, getshariahconfig, residualListApi } from '../components/ApiProperty';
import { Modal } from 'react-bootstrap';

Chart.register(PieController, ArcElement, Tooltip, Legend, Title, BarController, BarElement, CategoryScale, LinearScale, DoughnutController);


const Navigation = () => {
  const navigate = useNavigate();
  const { setIsChatbotMinimized } = useChatbot();
  const location = useLocation();
  const currentPath = location.pathname;
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [canDownloadShariahReport, setCanDownloadShariahReport] = useState(false);
  const [canDownloadComplaintsReport, setCanDownloadComplaintsReport] = useState(false);
  const [canDownloadMediaReport, setCanDownloadMediaReport] = useState(false);
  const [canDownloadOperationalReport, setCanDownloadOperationalReport] = useState(false);
  const [canDownloadLeadershipReport, setCanDownloadLeadershipReport] = useState(false);
  const [canDownloadComplianceReport, setCanDownloadComplianceReport] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [departmentDetails, setDepartmentDetails] = useState({});
  const chartContainerRef = useRef(null);
  const chartInstanceRefpdf = useRef(null); // This holds the Chart instance
  const chartRefpdf = useRef(null);
  const [Userdetails, setUserDetails] = useState(null);
  const [flattenedUsers, setFlattenedUsers] = useState([]);
  const [selectedRange, setSelectedRange] = useState('All');
  const createdTemplateChartInstance = useRef(null);
  const [userDateFilter, setUserDateFilter] = useState("All");
  const [selectedTemplateDept, setSelectedTemplateDept] = useState(null);
  const [canShowChart, setCanShowChart] = useState(false); // <-- NEW
  const [barChartData, setBarChartData] = useState([0, 0, 0]); // Created, Modified, Inactive 
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [dateFilter, setDateFilter] = React.useState('all'); // default 'all'
  const [dateFilterPdf, setDateFilterpdf] = useState("All");
  const userDept = localStorage.getItem('dept');
  const [modalMessage, setModalMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // 'success', 'warning', 'danger'
  let csrfToken = sessionStorage.getItem("tokenizedSession");
  const [isResidualRiskUser, setIsResidualRiskUser] = useState(false);
  const [isShariahRiskUser, setIsShariahRiskUser] = useState(false);
  const [isCustomerComplaintsUser, setIsCustomerComplaintsUser] = useState(false);
  const [isMediaUser, setIsMediaUser] = useState(false);
  const [isOperationalUser, setIsOperationalUser] = useState(false);
  const [isLeadershipUser, setIsLeadershipUser] = useState(false);
  const [isComplianceUser, setIsComplianceUser] = useState(false);
  const [isRmaExpanded, setIsRmaExpanded] = useState(false);
  const [isRmaMappingExpanded, setIsRmaMappingExpanded] = useState(false);
  const [isRmaReportsExpanded, setIsRmaReportsExpanded] = useState(false);
  


  const [showDoughnut, setShowDoughnut] = useState(true); // default to true
  const [tableDetails, setTableDetails] = useState({
    created: [],
    updated: [],
    inactive: []
  }); // For table details



  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setIsLoading(true);

      const loggedInUserId = String(
        localStorage.getItem("userid") || ""
      );

      const baseConfig = {
        headers: {
          userId: loggedInUserId,
          "x-csrf-token": csrfToken,
        },
        withCredentials: true,
      };

      // Fetch Shariah Risk permissions.
      const shariahResponse = await axios.post(
        getshariahconfig,
        {},
        {
          ...baseConfig,
          params: {
            userId: loggedInUserId,
            templateName: "Shariah Risk",
          },
        }
      );

      const shariahPermissions = Array.isArray(shariahResponse.data?.data)
        ? shariahResponse.data.data
        : [];

      const hasShariahPermission = shariahPermissions.some(
        (item) =>
          String(item.userId) === loggedInUserId &&
          item.download === "Y"
      );

      setCanDownloadShariahReport(hasShariahPermission);

      // Fetch Customer Complaints permissions.
      const complaintsResponse = await axios.post(
        getshariahconfig,
        {},
        {
          ...baseConfig,
          params: {
            userId: loggedInUserId,
            templateName: "Customer Complaints",
          },
        }
      );

      const complaintsPermissions = Array.isArray(complaintsResponse.data?.data)
        ? complaintsResponse.data.data
        : [];

      const hasComplaintsPermission = complaintsPermissions.some(
        (item) =>
          String(item.userId) === loggedInUserId &&
          item.download === "Y"
      );

      setCanDownloadComplaintsReport(hasComplaintsPermission);

      const mediaResponse = await axios.post(
        getshariahconfig,
        {},
        {
          ...baseConfig,
          params: {
            userId: loggedInUserId,
            templateName: "Media Publicity",
          },
        }
      );

      const mediaPermissions = Array.isArray(mediaResponse.data?.data)
        ? mediaResponse.data.data
        : [];

      const hasMediaPermission = mediaPermissions.some(
        (item) =>
          String(item.userId) === loggedInUserId &&
          item.download === "Y"
      );

      setCanDownloadMediaReport(hasMediaPermission);

      const operationalResponse = await axios.post(
        getshariahconfig,
        {},
        {
          ...baseConfig,
          params: {
            userId: loggedInUserId,
            templateName: "Operational Thresholds",
          },
        }
      );

      const operationalPermissions = Array.isArray(operationalResponse.data?.data)
        ? operationalResponse.data.data
        : [];

      const hasOperationalPermission = operationalPermissions.some(
        (item) =>
          String(item.userId) === loggedInUserId &&
          item.download === "Y"
      );

      setCanDownloadOperationalReport(hasOperationalPermission);

      const leadershipResponse = await axios.post(
        getshariahconfig,
        {},
        {
          ...baseConfig,
          params: {
            userId: loggedInUserId,
            templateName: "Leadership Thresholds",
          },
        }
      );

      const leadershipPermissions = Array.isArray(leadershipResponse.data?.data)
        ? leadershipResponse.data.data
        : [];

      const hasLeadershipPermission = leadershipPermissions.some(
        (item) =>
          String(item.userId) === loggedInUserId &&
          item.download === "Y"
      );

      setCanDownloadLeadershipReport(hasLeadershipPermission);

      const complianceResponse = await axios.post(
        getshariahconfig,
        {},
        {
          ...baseConfig,
          params: {
            userId: loggedInUserId,
            templateName: "Leadership Thresholds",
          },
        }
      );

      const compliancePermissions = Array.isArray(complianceResponse.data?.data)
        ? complianceResponse.data.data
        : [];

      const hasCompliancePermission = compliancePermissions.some(
        (item) =>
          String(item.userId) === loggedInUserId &&
          item.download === "Y"
      );

      setCanDownloadComplianceReport(hasCompliancePermission);



    } catch (error) {
      console.error("Error fetching report permissions:", error);

      setCanDownloadShariahReport(false);
      setCanDownloadComplaintsReport(false);
      setCanDownloadMediaReport(false);
      setCanDownloadComplianceReport(false);
      setCanDownloadOperationalReport(false);
      setCanDownloadLeadershipReport(false);

    } finally {
      setIsLoading(false);
    }
  };



  useEffect(() => {
    fetchWorkflowConfig();
  }, []);

  const fetchWorkflowConfig = async () => {
    try {
      setIsLoading(true);

      const userId = localStorage.getItem("userid");

      const config = {
        headers: {
          userId,
          "x-csrf-token": csrfToken,
        },
        withCredentials: true,
        params: {
          userId,
          templateName: "All",
        },
      };

      const response = await axios.post(
        residualListApi,
        {},
        config
      );

      const permissions = response.data?.permissions || [];

      // Find workflow by template name, ignoring case and whitespace.
      const findWorkflow = (templateName) =>
        permissions.find(
          (item) =>
            item.template?.trim().toLowerCase() ===
            templateName.toLowerCase()
            && item.Active?.toUpperCase() === "Y"
        );

      // Extract workflow roles.
      const hasRole = (templateName, roleName) => {
        const workflow = findWorkflow(templateName);

        return (workflow?.workflow_action || "")
          .split(",")
          .map((role) => role.trim().toLowerCase())
          .includes(roleName.toLowerCase());
      };

      // Shariah
      const hasShariahRiskUserPermission = hasRole(
        "Shariah",
        "Risk SuperUser"
      );

      // Residual Operational Risk
      const hasResidualRiskUserPermission = hasRole(
        "Residual Operational Risk",
        "Risk SuperUser"
      );

      // Customer Complaints
      const hasCustomerComplaintsPermission =
        hasRole("Risk_customer_complaints", "Risk SuperUser");

      const hasMediaPermission =
        hasRole("Risk_media_publicity", "Risk SuperUser");

      const hasOperationalPermission =
        hasRole("Risk_operational_thresholds", "Risk SuperUser");
      const hasLeadershipPermission =
        hasRole("Risk_leadership_thresholds", "Risk SuperUser");
      const hasCompliancePermission =
        hasRole("Risk_compliance", "Risk SuperUser");

      setIsShariahRiskUser(hasShariahRiskUserPermission);
      setIsResidualRiskUser(hasResidualRiskUserPermission);
      setIsCustomerComplaintsUser(hasCustomerComplaintsPermission);
      setIsMediaUser(hasMediaPermission);
      setIsOperationalUser(hasOperationalPermission);
      setIsLeadershipUser(hasLeadershipPermission);
      setIsComplianceUser(hasCompliancePermission);

      // Preserve existing table data.
      const apiData = permissions.map((item) => ({
        template: item.template,
        workflow: item.workflow,
        active: item.Active,
        workflowAction: item.workflow_action || "",
        roles: item.workflow_action
          ? item.workflow_action
            .split(",")
            .map((role) => role.trim())
          : [],
      }));

      setUsers(apiData);
      setFilteredUsers(apiData);

      console.log("Shariah Risk User:", hasShariahRiskUserPermission);
      console.log("Residual Risk User:", hasResidualRiskUserPermission);
      console.log("Customer Complaints User:", hasCustomerComplaintsPermission);

    } catch (error) {
      console.error("Error fetching workflow configuration:", error);

      setIsShariahRiskUser(false);
      setIsResidualRiskUser(false);
      setIsCustomerComplaintsUser(false);
      setIsMediaUser(false);
      setIsOperationalUser(false);
      setIsLeadershipUser(false);
      setIsComplianceUser(false);
    } finally {
      setIsLoading(false);
    }
  };


  // Check active routes for dropdown Template Creatuib 
  const templateRoutes = [
    '/gapsyFbc',
    '/gapsyIbm',
    '/gapsyMet',
    '/gapsyibmCreate',
    '/preview',
    '/gapsyTempAssign',
    '/gapsyReAssign'
  ];

  // Check if the current path matches any child route
  const isTemplateActive = templateRoutes.some(route => currentPath.startsWith(route));


  const handleFbc = (e) => {
    e.preventDefault();
    navigate('/gapsyFbc');
    // Additional logic if needed
  };

  const handleUserMapping = (e) => {
    e.preventDefault();
    navigate('/gapsyusermapping');
    // Additional logic if needed
  };

  const handleRoleandMap = (e) => {
    e.preventDefault();
    navigate('/gapsyuserroleandmapping');
    // Additional logic if needed
  };

  const handleParameterMap = (e) => {
    e.preventDefault();
    navigate('/gapsyparametermapping');
    // Additional logic if needed
  };

  const handleUserConfig = (e) => {
    e.preventDefault();
    navigate('/gapsyuserconfig');
    // Additional logic if needed
  };

  const handleShariah = (e) => {
    e.preventDefault();
    navigate('/GapsyShariahAdmin');
  }

  const handleShariahList = (e) => {
    e.preventDefault();
    navigate('/GapsyShariahListReinstate');
  }

  const handleComplaintList = (e) => {
    e.preventDefault();
    navigate('/GapsyComplaint');
  }

  const handleList = (e) => {
    e.preventDefault();
    navigate('/GapsyComplaintList');
  }

  const handleMedia = (e) => {
    e.preventDefault();
    navigate('/GapsyMedia');
  }

  const handleLeadership = (e) => {
    e.preventDefault();
    navigate('/GapsyLeadership');
  }

  const handleOperational = (e) => {
    e.preventDefault();
    navigate('/GapsyOperational');
  }

  const handleCompliance = (e) => {
    e.preventDefault();
    navigate('/GapsyCompliance');
  }

  const handleNewMapping = (e) => {
    e.preventDefault();
    navigate('/GapsyNewMapping');
  }

  const handleNewReport = (e) => {
    e.preventDefault();
    navigate('/GapsyNewReport');
  }

  const handleMediaList = (e) => {
    e.preventDefault();
    navigate('/GapsyMediaList');
  }

  const handleLeadershipList = (e) => {
    e.preventDefault();
    navigate('/GapsyLeadershipList');
  }

  const handleOperationalList = (e) => {
    e.preventDefault();
    navigate('/GapsyOperationalList');
  }

  const handleComplianceList = (e) => {
    e.preventDefault();
    navigate('/GapsyComplianceList');
  }

  const handleShariahReinstate = (e) => {
    e.preventDefault();
    navigate('/GapsyShariahReinstate');
  }

  const handleShariahOverride = (e) => {
    e.preventDefault();
    navigate('/GapsyShariahOverride');
  }

  const handleShariahOverrideList = (e) => {
    e.preventDefault();
    navigate('/GapsyShariahOverrideList');
  }


  const handleComplaintOverrideList = (e) => {
    e.preventDefault();
    navigate('/GapsyComplaintOverrideList');
  }

  const handleMediaOverrideList = (e) => {
    e.preventDefault();
    navigate('/GapsyMediaOverrideList');
  }

  const handleLeadershipOverrideList = (e) => {
    e.preventDefault();
    navigate('/GapsyLeadershipOverrideList');
  }

  const handleOperationalOverrideList = (e) => {
    e.preventDefault();
    navigate('/GapsyOperationalOverrideList');
  }

  const handleComplianceOverrideList = (e) => {
    e.preventDefault();
    navigate('/GapsyComplianceOverrideList');
  }

  const handleResidualOverrideList = (e) => {
    e.preventDefault();
    navigate('/GapsyResidualOverrideList');
  }

  const handleResidualReinstateList = (e) => {
    e.preventDefault();
    navigate('/GapsyResidualReinstateList');
  }

  const handleShariahMapping = (e) => {
    e.preventDefault();
    navigate('/GapsyShariahAdmin');
  }

  const handleShariahConfiguration = (e) => {
    e.preventDefault();
    navigate('/GapsyShariahConfiguration');
  }


  const handleComplaintsConfiguration = (e) => {
    e.preventDefault();
    navigate('/GapsyComplaintsConfiguration');
  }


  const handleResidualORisk = (e) => {
    e.preventDefault();
    navigate('/GapsyResidualListConfig');
  }

  const handleComplaintsRisk = (e) => {
    e.preventDefault();
    navigate('/GapsyComplaintsListConfig');
  }

  const handleIbm = (e) => {
    e.preventDefault();
    navigate('/gapsyIbm');
  };

  const handleDashboardAI = () => {
    // Open the chatbot
    setIsChatbotMinimized(false);
  };

  const handleModiyTemplate = (e) => {
    e.preventDefault();
    navigate('/gapsyMet');
  }

  const handleDashboard = (e) => {
    e.preventDefault();
    navigate('/gapsyAdashboard');
  }

  const handleShariahReport = (e) => {
    e.preventDefault();
    navigate('/GapsyShariahReport');
  }

  const handleComplaintsReport = (e) => {
    e.preventDefault();
    navigate('/GapsyComplaintsReport');
  }

  const handleMediaReport = (e) => {
    e.preventDefault();
    navigate('/GapsyMediaReport');
  }

  const handleOperationalReport = (e) => {
    e.preventDefault();
    navigate('/GapsyOperationalReport');
  }

  const handleLeadershipReport = (e) => {
    e.preventDefault();
    navigate('/GapsyLeadershipReport');
  }

  const handleComplianceReport = (e) => {
    e.preventDefault();
    navigate('/GapsyComplianceReport');
  }

  function capitalizeFirstLetter(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }
  const dept = localStorage.getItem('dept');
  const userId = localStorage.getItem('userid');
  const userRole = localStorage.getItem('userRole');

  const generateDoughnutChart = async () => {
    try {
      setIsLoading(true);


      const department = localStorage.getItem('dept');
      const activity = 'R';

      const isAllowed = department === 'IT' && (userRole === 'Admin' || userRole === 'Superuser');
      setCanShowChart(isAllowed);
      if (!isAllowed) return;


      const config = {
        headers: { userId, "x-csrf-token": csrfToken },
        withCredentials: true,
        params: { userId, userRole, dept: department, Activity: activity },
      };

      const response = await axios.post(generatereport, {}, config);
      if (response.status !== 200) throw new Error('Failed to fetch data');
      const result = response.data;
      if (result.status === 'success') {
        const departmentData = result.DepartmentDetails;
        const userDetails = result.UserDetails;
        setDepartmentDetails(departmentData);
        setUserDetails(userDetails);

        const departments = Object.keys(departmentData);
        const flatList = [];

        departments.forEach((dept) => {
          const users = userDetails[dept] || [];
          users.forEach((user) => {
            flatList.push({
              sno: flatList.length + 1,
              userId: user.userId,
              fullName: `${capitalizeFirstLetter(user.firstName)} ${capitalizeFirstLetter(user.lastName)}`,
              userRole: user.userRole,
              dept: user.orgHierarchy,
              createdBy: user.User_Activated_By,
              createdDate: user.accountCreatedDate,
              totalLogins: user.totalLogins,
              today_login: user.todayLogins,
              last_3days_logins: user.last3DaysLogins,
              last_7days_logins: user.last7DaysLogins,
              last_30Days_Logins: user.last30DaysLogins,
              lastActivity: user.lastActivity,
              active: user.active,
              frequencyActivity: user.Frequnce_activity,
              frequencyActivity_today: user.Frequency_activity_today,
              frequencyActivity_3days: user.Frequency_activity_3days,
              frequencyActivity_7days: user.Frequency_activity_7days,
              frequencyActivity_30days: user.Frequency_activity_30days,
            });
          });
        });

        setFlattenedUsers(flatList);

        const totals = departments.map((dep) => {
          const { Admin = 0, Maker = 0, Checker = 0, Superuser = 0 } = departmentData[dep];
          return Admin + Maker + Checker + Superuser;
        });


        const chartPayload = {
          labels: departments,
          datasets: [{
            data: totals,
            backgroundColor: ['#FFCE56', '#9966FF', '#7AC74F', '#FF69B4'],
            hoverOffset: 4,
          }],
          totalUsers: totals.reduce((sum, val) => sum + val, 0),
        };
        const canvas = chartRefpdf.current;
        if (canvas) {
          const ctx = canvas.getContext('2d');
          if (chartInstanceRefpdf.current) chartInstanceRefpdf.current.destroy();

          chartInstanceRefpdf.current = new Chart(ctx, {
            type: 'doughnut',
            data: chartPayload,
            options: {
              responsive: true,
              maintainAspectRatio: false,
              animation: {

                // In the onComplete callback:
                onComplete: async () => {
                  const chartImageCanvas = await html2canvas(canvas, { scale: 3 });
                  const imgData = chartImageCanvas.toDataURL('image/png');
                  handleDownloadPDF(imgData, flatList); // Pass flatList directly
                },
              },
              plugins: {
                legend: {
                  display: true,
                  position: 'bottom',
                  align: 'center',
                  labels: {
                    color: 'black',
                    font: { size: 15, weight: 'bold', family: 'Arial, sans-serif' },
                    boxWidth: 15,
                    padding: 10,
                    generateLabels(chart) {
                      const dataset = chart.data.datasets[0];
                      const labels = chart.data.labels;
                      return labels.map((label, i) => ({
                        text: `${label} (${dataset.data[i]})`,
                        fillStyle: dataset.backgroundColor[i],
                        strokeStyle: dataset.borderColor ? dataset.borderColor[i] : '',
                        lineWidth: 1,
                        hidden: !chart.isDatasetVisible(0),
                        index: i,
                      }));
                    },
                  },
                },
                tooltip: { enabled: true },
              },
              elements: { arc: { borderWidth: 0 } },
              onClick: (e, elements) => {
                if (elements.length > 0) {
                  const index = elements[0].index;
                  const clickedDept = chartPayload.labels[index];
                  setSelectedDepartment(clickedDept);
                }
              },
            },
            plugins: [
              {
                id: 'segment3DEffect',
                afterDatasetDraw(chart) {
                  const { ctx } = chart;
                  const meta = chart.getDatasetMeta(0);
                  const dataset = chart.data.datasets[0];

                  ctx.save();
                  meta.data.forEach((arc, index) => {
                    const { x, y, startAngle, endAngle, outerRadius, innerRadius } = arc;
                    const gradient = ctx.createRadialGradient(x, y, innerRadius, x, y, outerRadius);
                    // const baseColor = dataset.backgroundColor[index];
                    let baseColor = dataset.backgroundColor[index];
                    if (!baseColor) {
                      // Use a default color if undefined
                      const defaultColors = ['#FFCE56', '#9966FF', '#7AC74F', '#FF69B4'];
                      baseColor = defaultColors[index % defaultColors.length];
                    }
                    gradient.addColorStop(0, 'rgba(255, 255, 255, 0.3)');
                    gradient.addColorStop(0.5, baseColor);
                    gradient.addColorStop(1, 'rgba(0, 0, 0, 0.15)');

                    ctx.fillStyle = gradient;

                    ctx.beginPath();
                    ctx.moveTo(x, y);
                    ctx.arc(x, y, outerRadius, startAngle, endAngle);
                    ctx.arc(x, y, innerRadius, endAngle, startAngle, true);
                    ctx.closePath();
                    ctx.fill();

                    ctx.shadowColor = 'rgba(0,0,0,0.08)';
                    ctx.shadowBlur = 3;
                    ctx.shadowOffsetX = 1;
                    ctx.shadowOffsetY = 1;

                    ctx.strokeStyle = 'rgba(0, 0, 0, 0.08)';
                    ctx.lineWidth = 1;
                    ctx.beginPath();
                    ctx.arc(x, y, outerRadius, startAngle, endAngle);
                    ctx.arc(x, y, innerRadius, endAngle, startAngle, true);
                    ctx.closePath();
                    ctx.stroke();

                    ctx.shadowColor = 'transparent';
                    ctx.shadowBlur = 0;
                    ctx.shadowOffsetX = 0;
                    ctx.shadowOffsetY = 0;
                  });
                  ctx.restore();
                },
              },
              {
                id: 'centerText',
                beforeDraw(chart) {
                  const { ctx, chartArea, data } = chart;
                  const total = data.totalUsers || 0;
                  ctx.save();
                  ctx.textAlign = 'center';
                  ctx.textBaseline = 'middle';
                  ctx.font = '20px Arial';
                  ctx.fillStyle = 'black';
                  ctx.fillText('Total', (chartArea.left + chartArea.right) / 2, (chartArea.top + chartArea.bottom) / 2 - 20);
                  ctx.font = '30px Arial';
                  ctx.fillText(total.toString(), (chartArea.left + chartArea.right) / 2, (chartArea.top + chartArea.bottom) / 2 + 10);
                  ctx.restore();
                },
              },
              {
                id: 'segmentCounts',
                afterDatasetDraw(chart) {
                  const { ctx } = chart;
                  const dataset = chart.data.datasets[0];
                  const meta = chart.getDatasetMeta(0);

                  ctx.save();
                  ctx.fillStyle = 'black';
                  ctx.font = 'bold 14px Arial';
                  ctx.textAlign = 'center';
                  ctx.textBaseline = 'middle';

                  meta.data.forEach((arc, index) => {
                    const { x, y } = arc.tooltipPosition();
                    const value = dataset.data[index];
                    ctx.fillText(value, x, y);
                  });

                  ctx.restore();
                },
              },
            ],

          });

        }
      }
    } catch (error) {
      console.error('Chart Generation Error:', error);
    }
  };


  const handleDownloadPDF = async (imgData, usersData = flattenedUsers) => {

    const pdf = new jsPDF("l", "mm", "a4"); // Landscape
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();



    // Border and Title
    pdf.setLineWidth(0.5);
    pdf.setDrawColor(0, 0, 0);
    pdf.rect(10, 10, pageWidth - 20, pageHeight - 20);


    pdf.setFontSize(15);
    pdf.setFont("helvetica", "bold");
    pdf.text("Audit Report - Users Summary", pageWidth / 2, 18, { align: "center" });


    // Meta Data
    const userId = localStorage.getItem("userid") || "UnknownUser";
    const userRole = localStorage.getItem("userRole") || "UnknownRole";
    const userName = localStorage.getItem("username") || "Unknown Name";
    const dept = localStorage.getItem("dept") || "Unknown Department";
    const downloadTime = new Date().toLocaleString();

    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(9);
    pdf.setTextColor(60, 60, 60);

    let y = 25;
    const lineHeight = 5;
    pdf.setFontSize(8);
    pdf.setTextColor(60, 60, 60);

    // ➤ Department on the left, Report Interval on the right (same line)
    pdf.text(`Department : ${dept}`, 20, y);
    pdf.text(`Report Interval : All Days`, pageWidth - 20, y, { align: "right" });

    // ➤ The rest below
    y += lineHeight;
    pdf.text(`Generated By : ${userId} (Admin)`, 20, y);
    y += lineHeight;
    pdf.text(`Generated On : ${downloadTime}`, 20, y);

    // Chart Drawing
    const imgWidth = 55.23;
    const imgHeight = 50.09;
    const chartX = (pageWidth - imgWidth) / 2;
    const chartY = 45;
    pdf.addImage(imgData, "PNG", chartX, chartY, imgWidth, imgHeight);

    const loginFieldMap = {
      Today: "today_login",
      "Last 3 Days": "last_3days_logins",
      "Last 7 Days": "last_7days_logins",
      "Last 30 Days": "last_30Days_Logins",
      All: "totalLogins",
    };
    const loginLabelMap = {
      Today: "No. of Logins (Today)",
      "Last 3 Days": "No. of Logins (Since Last 3 Days)",
      "Last 7 Days": "No. of Logins (Since Last 7 Days)",
      "Last 30 Days": "No. of Logins (Since Last 30 Days)",
      All: "No. of Logins",
    };

    const frequencyFieldMap = {
      Today: "frequencyActivity_today",
      "Last 3 Days": "frequencyActivity_3days",
      "Last 7 Days": "frequencyActivity_7days",
      "Last 30 Days": "frequencyActivity_30days",
      All: "frequencyActivity",
    };
    const frequencyLabelMap = {
      Today: "Frequent Activity (Today)",
      "Last 3 Days": "Frequent Activity (3 Days)",
      "Last 7 Days": "Frequent Activity (7 Days)",
      "Last 30 Days": "Frequent Activity (30 Days)",
      All: "User Frequent Activity",
    };

    const loginField = loginFieldMap[selectedRange] || "totalLogins";
    const loginLabel = loginLabelMap[selectedRange] || "No. of Logins";
    const frequencyField = frequencyFieldMap[selectedRange] || "frequencyActivity";
    const frequencyLabel = frequencyLabelMap[selectedRange] || "Frequent Activity";

    // Table
    const headers = [[
      "S.No", "User ID", "User Name", "User Role", "User Department",
      "User Status", "User Activated Date", "User Activated By",
      loginLabel, "User Last Activity", frequencyLabel,
    ]];

    const data = usersData.map((user) => {
      // Handle last activity
      let lastActivity;
      const rawLastActivity = user.lastActivity;

      if (rawLastActivity === "New User") {
        lastActivity = "No Recent Activity";
      } else if (
        rawLastActivity === "Generated-Review Summary" ||
        rawLastActivity === "Generated-Data Summary" ||
        rawLastActivity === "Generated-Template Summary"
      ) {
        lastActivity = `${rawLastActivity} Report`;
      } else {
        lastActivity = rawLastActivity || "-";
      }

      // Handle frequency activity
      const frequencyRaw = user[frequencyField];
      let frequencyDisplay;

      if (frequencyRaw === "New User" || frequencyRaw == null) {
        frequencyDisplay = "No Frequency Activity";
      } else if (
        frequencyRaw === "Generated-Review Summary" ||
        frequencyRaw === "Generated-Data Summary" ||
        frequencyRaw === "Generated-Template Summary"
      ) {
        frequencyDisplay = `${frequencyRaw} Report`;
      } else {
        frequencyDisplay = frequencyRaw;
      }

      return [
        user.sno ?? "-",
        user.userId || "-",
        user.fullName || "-",
        user.userRole || "-",
        user.dept || "-",
        user.active === "Y" ? "Active" : user.active === "N" ? "Inactive" : "-",
        user.createdDate ? new Date(user.createdDate).toISOString().split("T")[0] : "-",
        user.createdBy || "-",
        user[loginField] ?? "-",
        lastActivity,
        frequencyDisplay
      ];
    });


    autoTable(pdf, {
      startY: chartY + imgHeight + 10,
      head: headers,
      body: data,
      styles: {
        fontSize: 6.5,
        cellPadding: 1.5,
        halign: "left",
        valign: "middle",
        overflow: "linebreak",
        minCellHeight: 5,
      },
      headStyles: {
        fillColor: [245, 245, 245],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        fontSize: 6.5,
        halign: "left",
        valign: "middle",
        lineWidth: 0.1,
        lineColor: 180,
      },
      bodyStyles: {
        textColor: 50,
        lineWidth: 0.1,
        lineColor: 200,
        halign: "left",
      },
      theme: "grid",

      didDrawPage: function () {
        pdf.setLineWidth(0.8);
        pdf.setDrawColor(0, 0, 0);
        pdf.rect(10, 10, pageWidth - 20, pageHeight - 20);
      },
    });
    setIsLoading(false);

    pdf.save(`Audit Report - Users Summary_${Date.now()}.pdf`);
  };



  const handleDepartmentClick = async (dept) => {
    setSelectedTemplateDept(dept); // Store for later use
    try {
      const userId = Number(localStorage.getItem('userid'));
      const userRole = localStorage.getItem('userRole');
      const department = localStorage.getItem('dept');
      const activity = 'C';
      const config = {
        headers: { userId, "x-csrf-token": csrfToken },
        withCredentials: true,
        params: { userId, userRole, Activity: activity, dept: department },
      };

      const response = await axios.post(Audit, {}, config);


      const actions = response.data.userDetails.actions;
      const inactiveTemplates = response.data.inactiveTemplates[dept];

      let createdCount = 0;
      let updatedCount = 0;
      let inactiveCount = 0;

      let createdTables = [];
      let updatedTables = [];
      let inactiveTables = [];

      actions.forEach((action) => {
        if (action.actionType === 'Created a Template' && action.actionDetails[dept]) {
          createdCount = action.actionDetails[dept].count;
          createdTables = action.actionDetails[dept].tables;
        }
        if (action.actionType === 'Updated a Template' && action.actionDetails[dept]) {
          updatedCount = action.actionDetails[dept].count;
          updatedTables = action.actionDetails[dept].tables;
        }
      });

      if (inactiveTemplates && Array.isArray(inactiveTemplates.tables)) {
        inactiveCount = inactiveTemplates.count;
        inactiveTables = inactiveTemplates.tables;
      }

      if (createdTemplateChartInstance.current) {
        createdTemplateChartInstance.current.data.datasets[0].data = [createdCount, updatedCount, inactiveCount];
        createdTemplateChartInstance.current.update();
      }

      setBarChartData([createdCount, updatedCount, inactiveCount]);
      setTableDetails({
        created: createdTables,
        updated: updatedTables,
        inactive: inactiveTables,
      });

    } catch (err) {
      console.error(`Failed to fetch data for department ${dept}:`, err);
    }
  };

  const handleGenerateAdminReport = async (dateFilterPdf) => {
    try {
      const userId = Number(localStorage.getItem("userid"));
      const userRole = localStorage.getItem("userRole");
      const department = localStorage.getItem("dept");
      const activity = 'R';

      const config = {
        headers: { userId, "x-csrf-token": csrfToken },
        withCredentials: true,
        params: { userId, userRole, Activity: activity, dept: department },
      };

      const response = await axios.post(Audit, {}, config);
      const actions = response.data.userDetails.actions;
      const inactiveTemplates = response.data.inactiveTemplates;

      // Get list of inactive table names for quick lookup
      const inactiveTableSet = new Set();
      Object.values(inactiveTemplates || {}).forEach(deptObj => {
        deptObj.tables.forEach(table => {
          inactiveTableSet.add(table.tableName);
        });
      });

      // Extract created templates
      const createdAction = actions.find(a => a.actionType === "Created a Template");
      if (!createdAction) return;

      const createdDetails = createdAction.actionDetails;
      const flattenedCreatedData = [];

      Object.entries(createdDetails).forEach(([dept, deptData]) => {
        deptData.tables.forEach((table) => {
          table.details.forEach((detail) => {
            const info = detail.templateInfo?.template_info;
            if (
              detail.completed_activity === "Created a Template" &&
              info &&
              isWithinDateRange(detail.Timestamp, dateFilterPdf)
            ) {
              const tableName = detail.Tablename;
              const isActive = inactiveTableSet.has(tableName) ? "In-Active" : "Active";

              flattenedCreatedData.push({
                department: dept,
                tableName,
                createdBy: info.created_by,
                createdDate: info.created_date,
                checker: info.checker,
                numCols: info.num_of_cols,
                numericCount: info.numeric_type_count,
                charCount: info.char_type_count,
                dateCount: info.date_type_count,
                isActive,
              });
            }
          });
        });
      });
      // Extract updated templates
      const updatedAction = actions.find(a => a.actionType === "Updated a Template");
      let flattenedUpdatedData = [];
      if (updatedAction) {
        const updatedDetails = updatedAction.actionDetails;
        Object.entries(updatedDetails).forEach(([dept, deptData]) => {
          deptData.tables.forEach((table) => {
            table.details.forEach((detail) => {
              if (detail.completed_activity === 'Updated a Template') {
                flattenedUpdatedData.push({
                  department: dept,
                  tableName: detail.Tablename,
                  modifiedBy: detail.Modified_By || '',
                  modifiedDate: detail.Modified_Date || '',
                });
              }
            });
          });
        });
      }
      // Merge created + updated data
      const updatedMap = {};
      flattenedUpdatedData.forEach((upd) => {
        const key = `${upd.department}_${upd.tableName}`;
        updatedMap[key] = upd;
      });

      const mergedData = flattenedCreatedData.map((created) => {
        const key = `${created.department}_${created.tableName}`;
        const updated = updatedMap[key];
        return {
          ...created,
          modifiedBy: updated?.modifiedBy || '',
          modifiedDate: updated?.modifiedDate || '',
        };
      });


      const createdCount = mergedData.length;
      const modifiedCount = mergedData.filter(item => item.modifiedBy).length;
      const inactiveCount = mergedData.filter(item => item.isActive === "In-Active").length;

      const barChartData = [createdCount, modifiedCount, inactiveCount];


      const tableDetails = {
        created: mergedData,
        updated: mergedData.filter(item => item.modifiedBy),
        inactive: mergedData.filter(item => item.isActive === "In-Active"),
      };

      let doughnutChartData = null;
      if (department === "IT") {
        const deptCountMap = {};

        mergedData.forEach(item => {
          if (!deptCountMap[item.department]) {
            deptCountMap[item.department] = 0;
          }
          deptCountMap[item.department]++;
        });

        const labels = Object.keys(deptCountMap);
        const data = Object.values(deptCountMap);

        const backgroundColors = labels.map(
          (_, i) => `hsl(${(i * 45) % 360}, 70%, 60%)`
        );

        doughnutChartData = {
          labels,
          datasets: [
            {
              data,
              backgroundColor: backgroundColors,
            },
          ],
        };
      }
      // Generate chart image for PDF
      const chartImage = await generateChartImageByDept({
        userDept: department,
        templateData: mergedData,
        tableDetails,
        barChartData,
        doughnutChartData, // NEW
        setModalMessage,
        setMessageType,
      });


      // Send merged data to PDF generator
      await generateAdminPDF(chartImage, mergedData, dateFilterPdf);

    } catch (error) {
      console.error("Failed to generate report:", error);
    }
  };


  const generateChartImageByDept = async ({
    userDept,
    templateData,
    tableDetails,
    barChartData,
    doughnutChartData, // Accept it here
    setModalMessage,
    setMessageType,
  }) => {
    setIsLoading(true);
    const canvas = document.getElementById("hiddenExportChart");
    canvas.width = 500;
    canvas.height = 400;
    const ctx = canvas.getContext("2d");

    let chartInstance = null;

    // Destroy previous chart if any (safety)
    if (canvas._chartInstance) {
      canvas._chartInstance.destroy();
    }

    const totalCount =
      userDept === "IT"
        ? doughnutChartData?.datasets?.[0]?.data?.reduce((a, b) => a + b, 0)
        : barChartData?.reduce((a, b) => a + b, 0);

    if (!totalCount) {
      setModalMessage("No activity is available for the selected Interval");
      setMessageType("warning");
      return null;
    }


    // Chart configuration 

    if (userDept === "IT" && doughnutChartData) {

      const initialColors = ['#FFCE56', '#9966FF', '#7AC74F', '#FF69B4'];
      doughnutChartData.datasets[0].backgroundColor = initialColors;
      doughnutChartData.datasets[0].borderColor = initialColors;
      doughnutChartData.datasets[0].borderWidth = 1;

      chartInstance = new Chart(ctx, {
        type: "doughnut",
        data: doughnutChartData,
        options: {
          responsive: false,
          maintainAspectRatio: false,
          layout: {
            padding: { top: 30, bottom: 30, left: 30, right: 30 },
          },
          plugins: {
            legend: {
              display: true,
              position: "bottom",
              align: "center",
              labels: {
                color: "black",
                font: {
                  size: 15,
                  weight: "bold",
                  family: "Arial, sans-serif",
                },
                boxWidth: 15,
                padding: 10,
                generateLabels(chart) {
                  const dataset = chart.data.datasets[0];
                  const labels = chart.data.labels;
                  return labels.map((label, i) => ({
                    text: `${label} (${dataset.data[i]})`,
                    fillStyle: dataset.backgroundColor[i],
                    strokeStyle: dataset.borderColor ? dataset.borderColor[i] : "",
                    lineWidth: 1,
                    hidden: !chart.isDatasetVisible(0),
                    index: i,
                  }));
                },
              },
            },
            tooltip: { enabled: true },
          },
          clip: false,
          elements: {
            arc: {
              borderWidth: 0,
            },
          },
          onClick: async (e, elements) => {
            if (elements.length > 0) {
              const index = elements[0].index;
              const dept = doughnutChartData.labels[index];
              await handleDepartmentClick(dept);
            }
          },
        },
        plugins: [
          {
            id: "centerText",
            beforeDraw(chart) {
              const { ctx, chartArea, data } = chart;
              const total = data.datasets[0].data.reduce((a, b) => a + b, 0);

              ctx.save();
              ctx.textAlign = "center";
              ctx.textBaseline = "middle";

              ctx.font = "20px Arial";
              ctx.fillStyle = "black";
              ctx.fillText(
                "Total",
                (chartArea.left + chartArea.right) / 2,
                (chartArea.top + chartArea.bottom) / 2 - 20
              );

              ctx.font = "30px Arial";
              ctx.fillText(
                total.toString(),
                (chartArea.left + chartArea.right) / 2,
                (chartArea.top + chartArea.bottom) / 2 + 10
              );

              ctx.restore();
            },
          },
          {
            id: "segment3DEffect",
            afterDatasetDraw(chart) {
              const { ctx } = chart;
              const meta = chart.getDatasetMeta(0);
              const dataset = chart.data.datasets[0];

              ctx.save();

              meta.data.forEach((arc, index) => {
                const { x, y, startAngle, endAngle, outerRadius, innerRadius } = arc;

                const baseColor = dataset.backgroundColor[index];
                const gradient = ctx.createRadialGradient(
                  x,
                  y,
                  innerRadius,
                  x,
                  y,
                  outerRadius
                );
                gradient.addColorStop(0, "rgba(255, 255, 255, 0.3)");
                gradient.addColorStop(0.5, baseColor);
                gradient.addColorStop(1, "rgba(0, 0, 0, 0.15)");

                ctx.fillStyle = gradient;

                ctx.beginPath();
                ctx.moveTo(x, y);
                ctx.arc(x, y, outerRadius, startAngle, endAngle);
                ctx.arc(x, y, innerRadius, endAngle, startAngle, true);
                ctx.closePath();
                ctx.fill();

                ctx.shadowColor = "rgba(0,0,0,0.08)";
                ctx.shadowBlur = 3;
                ctx.shadowOffsetX = 1;
                ctx.shadowOffsetY = 1;

                ctx.strokeStyle = "rgba(0, 0, 0, 0.08)";
                ctx.lineWidth = 1;
                ctx.beginPath();
                ctx.arc(x, y, outerRadius, startAngle, endAngle);
                ctx.arc(x, y, innerRadius, endAngle, startAngle, true);
                ctx.closePath();
                ctx.stroke();

                ctx.shadowColor = "transparent";
                ctx.shadowBlur = 0;
                ctx.shadowOffsetX = 0;
                ctx.shadowOffsetY = 0;
              });

              ctx.restore();
            },
          },
          {
            id: "segmentCounts",
            afterDatasetDraw(chart) {
              const { ctx } = chart;
              const dataset = chart.data.datasets[0];
              const meta = chart.getDatasetMeta(0);

              ctx.save();
              ctx.fillStyle = "black";
              ctx.font = "bold 14px Arial";
              ctx.textAlign = "center";
              ctx.textBaseline = "middle";

              meta.data.forEach((arc, index) => {
                const { x, y } = arc.tooltipPosition();
                const value = dataset.data[index];
                ctx.fillText(value, x, y);
              });

              ctx.restore();
            },
          },
        ],
      });
    }
    else {
      const barLabels = [
        `Created (${tableDetails?.created?.length || 0})`,
        `Modified (${tableDetails?.updated?.length || 0})`,
        `Inactive (${tableDetails?.inactive?.length || 0})`,
      ];

      // Create gradient colors
      function createGradient(colorStart, colorEnd) {
        const gradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
        gradient.addColorStop(0, colorStart);
        gradient.addColorStop(1, colorEnd);
        return gradient;
      }

      const backgroundColors = [];
      backgroundColors.push(createGradient("#967aa1", "#07beb8")); // gradient1
      backgroundColors.push(createGradient("#967aa1", "#f25c54")); // gradient2
      backgroundColors.push(createGradient("#967aa1", "#133c55")); // gradient3
      chartInstance = new Chart(ctx, {
        type: "bar",
        data: {
          labels: barLabels,
          datasets: [
            {
              data: barChartData,
              backgroundColor: backgroundColors,
              borderRadius: 0,
              barPercentage: 0.5,
              categoryPercentage: 0.5,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { display: false },
          },
          scales: {
            x: {
              title: {
                display: true,
                text: "Activity",
                color: "black",
                font: {
                  size: 18,
                  weight: "bold",
                },
              },
              ticks: {
                color: "black",
                font: {
                  size: 15,
                  weight: "normal",
                },
              },
              grid: {
                display: false,
              },
            },
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: "Count",
                color: "black",
                font: {
                  size: 18,
                  weight: "bold",
                },
              },
              ticks: {
                color: "black",
                font: {
                  size: 18,
                  weight: "bold",
                },
                stepSize: 1,
                precision: 0,
              },
            },
          },
        },
      });
    }
    canvas._chartInstance = chartInstance;
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(canvas.toDataURL("image/png"));
      }, 1000); // slight delay for chart to render
    });
  };


  const handleCloseModal = () => {
    setModalMessage("");
    setMessageType("");
  };

  const generateAdminPDF = async (chartImage, mergedTemplateData, dateFilterPdf) => {

    const pdf = new jsPDF('landscape', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();

    //  Border
    pdf.setLineWidth(0.5);                  // ← Line width
    pdf.setDrawColor(0, 0, 0);              // ← Border color (black)
    pdf.rect(10, 10, pageWidth - 20, pageHeight - 20);


    //  Title
    pdf.setFontSize(15);
    pdf.setTextColor(40, 40, 40);
    pdf.setFont('helvetica', 'bold');
    pdf.text('Audit Report - Templates Summary', pageWidth / 2, 18, { align: 'center' });

    //  Format Report Interval Label
    const formatDateFilterLabel = (filter) => {
      switch (filter) {
        case 'All':
          return 'All Days';
        case 'Today':
          return 'Today';
        case 'Last 3 Days':
          return 'Last 3 days';
        case 'Last 7 Days':
          return 'Last 7 days';
        case 'Last 30 Days':
          return 'Last 30 days';
        default:
          return filter || 'Custom';
      }
    };

    const formattedDateLabel = formatDateFilterLabel(dateFilterPdf);
    //  Filter Label
    pdf.setFontSize(10);
    pdf.setFont('helvetica', 'normal');
    // 👤 User Info
    const userId = localStorage.getItem('userid') || 'UnknownUser';
    const dept = localStorage.getItem('dept') || 'Unknown Department';
    const downloadTime = new Date().toLocaleString();

    const formatLine = (label, value) => `${label}: ${value}`;

    let y = 25;
    const lineHeight = 5;
    pdf.setFontSize(8);
    pdf.setTextColor(60, 60, 60);

    // ➤ Department on the left, Report Interval on the right (same line)
    pdf.text(`Department : ${dept}`, 20, y);
    pdf.text(`Report Interval : ${formattedDateLabel}`, pageWidth - 20, y, { align: 'right' });

    // ➤ The rest below
    y += lineHeight;
    const userRoleLabel = dept === "IT" ? "Admin" : "Manager";
    pdf.text(`Generated By : ${userId} (${userRoleLabel})`, 20, y);

    y += lineHeight;
    pdf.text(`Generated On : ${downloadTime}`, 20, y);


    // 📊 Chart Image
    const imgWidth = 90.23;
    const imgHeight = 60.09;
    const chartX = (pageWidth - imgWidth) / 2;
    const chartY = 45;
    pdf.addImage(chartImage, 'PNG', chartX, chartY, imgWidth, imgHeight);

    // 📋 Table Headers
    const headers = [[
      'S.No',
      'Department',
      'Template Name',
      'Template Status',
      'Template Created By',
      'Template Created Date',
      'Template Modified By',
      'Template Modified Date',
      'Template Assigned To',
      'No. of Columns',
    ]];


    // 🔧 Format Helpers
    const formatTableName = (name) => {
      if (!name) return 'n/a';
      const nameWithoutPrefix = name.includes('_') ? name.substring(name.indexOf('_') + 1) : name;
      return nameWithoutPrefix
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    };


    const formatDate = (datetime) => datetime ? datetime.split(' ')[0] : '-';

    // 📄 Table Body
    const body = mergedTemplateData.map((item, index) => [
      index + 1,
      item.department,
      formatTableName(item.tableName),
      item.isActive,
      item.createdBy,
      formatDate(item.createdDate),
      item.modifiedBy || '-',
      formatDate(item.modifiedDate),
      item.checker || '-',
      item.numCols,
    ]);

    // 🧾 Table Rendering
    autoTable(pdf, {
      startY: chartY + imgHeight + 10,
      head: headers,
      body: body,
      styles: {
        fontSize: 6.5,
        cellPadding: 1.5,
        halign: 'left',
        valign: 'middle',
        overflow: 'linebreak',
        minCellHeight: 5
      },
      headStyles: {
        fillColor: [245, 245, 245],
        textColor: [0, 0, 0],
        fontStyle: 'bold',
        fontSize: 6.5,
        halign: 'left',
        valign: 'middle',
        lineWidth: 0.1,
        lineColor: 180,
      },
      bodyStyles: {
        textColor: 50,
        lineWidth: 0.1,
        lineColor: 200,
      },
      theme: 'grid',
      didDrawPage: () => {
        pdf.setDrawColor(0, 0, 0);
        pdf.rect(10, 10, pageWidth - 20, pageHeight - 20);
      }
    });

    setIsLoading(false);
    // 💾 Save File
    pdf.save(`Audit Report - Templates Summary_${Date.now()}.pdf`);
  };


  const isWithinDateRange = (dateStr, range) => {
    if (range === "All") return true;

    const targetDate = new Date(dateStr);
    const today = new Date();

    // Normalize both dates to midnight (ignore time)
    targetDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    const daysMap = {
      "Today": 0,
      "Last 3 Days": 2,  // Today + 2 previous = 3 days
      "Last 7 Days": 6,
      "Last 30 Days": 29,
    };
    const diffTime = today - targetDate;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    return diffDays >= 0 && diffDays <= daysMap[range];
  };

  const isWithinDateRangetemplate = (timestamp, range) => {
    if (range === 'All') return true;

    const daysMap = {
      'Today': 0,
      'Last 3 Days': 3,
      'Last 7 Days': 7,
      'Last 30 Days': 30,
    };

    const targetDate = new Date(timestamp);
    const today = new Date();

    // Remove time from comparison
    targetDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    const diffTime = today - targetDate;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    return diffDays <= daysMap[range];
  };

  const filteredByDate = filteredUsers.filter(user =>
    isWithinDateRange(user.accountCreatedDate, userDateFilter)
  );
  const renderTable = (title, data, type, count, dateFilter) => {
    const safeData = Array.isArray(data) ? data : [];

    const getDateLabel = () => {
      if (type === 'created') return 'Created Date';
      if (type === 'updated') return 'Modified Date';
      if (type === 'inactive') return 'Last Active Date';
      return 'Date';
    };
    const formatDate = (timestamp) => {
      if (!timestamp) return 'n/a';
      const date = new Date(timestamp);
      if (isNaN(date)) return 'n/a';

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    };

    const formatTableName = (name) => {
      if (!name) return 'n/a';
      const nameWithoutPrefix = name.includes('_') ? name.substring(name.indexOf('_') + 1) : name;
      return nameWithoutPrefix
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    };

    const filteredData = safeData.filter((item) => {
      const detail = item.details?.[0] || item.actionDetails?.[0];
      return isWithinDateRangetemplate(detail?.Timestamp, dateFilter);
    });



    return (
      <div style={{ marginBottom: '16px', textTransform: 'none' }}>
        <h5 style={{ marginBottom: '8px', textTransform: 'capitalize', fontSize: '0.9rem' }}>
          <span style={{ fontWeight: 'bold' }}>{title}</span>
          <span style={{ fontWeight: 'bold', marginLeft: '5px' }}>- {filteredData.length}</span>
        </h5>
        <hr style={{ margin: '4px 0 8px 0', borderColor: 'black', borderTopWidth: '1px' }} />


        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tbody>
            {filteredData.map((item, index) => {
              const detail = item.details?.[0] || item.actionDetails?.[0];
              const tableName = formatTableName(detail?.Tablename || item.tableName);
              const timestamp = formatDate(detail?.Timestamp);

              return (
                <React.Fragment key={index}>
                  <tr>
                    <td style={{ fontSize: '0.75rem', fontWeight: 'bold', paddingBottom: '2px' }}>
                      {tableName}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: '0.7rem', paddingBottom: '2px' }}>
                      {getDateLabel()} : {timestamp}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <hr style={{ margin: '4px 0', borderColor: 'black', borderTopWidth: '1px' }} />
                    </td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  const renderUserRoleTable = (role, filteredUsers) => {
    const formatDate = (dateString) => {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      if (isNaN(date)) return 'Invalid Date';

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    };

    const roleTitleMap = {
      admin: 'Manager',
      // add more roles here
    };

    const normalizedRole = role?.trim().toLowerCase() || '';
    const displayTitle = roleTitleMap[normalizedRole] || role;

    const filteredByDate = filteredUsers.filter(user =>
      isWithinDateRange(user.accountCreatedDate, userDateFilter)
    );

    return (
      <div style={{ marginBottom: '16px', textTransform: 'none' }}>
        <h5 style={{ marginBottom: '8px', textTransform: 'capitalize', fontSize: '0.9rem' }}>
          <span style={{ fontWeight: 'bold' }}>{displayTitle}</span>
          <span style={{ fontWeight: 'bold', marginLeft: '5px' }}>- {filteredByDate.length}</span>
        </h5>
        <hr style={{ margin: '4px 0 8px 0', borderColor: 'black', borderTopWidth: '1px' }} />
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tbody>
            {filteredByDate.map((user, index) => {
              const capitalize = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : '';
              const fullName = `${capitalize(user.firstName)} ${user.lastName || ''}`.trim();
              return (
                <React.Fragment key={index}>
                  <tr>
                    <td style={{ fontSize: '0.75rem', fontWeight: 'bold', paddingBottom: '2px' }}>
                      {fullName}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ fontSize: '0.7rem', paddingBottom: '2px' }}>
                      Date Created: {formatDate(user.accountCreatedDate)}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <hr style={{ margin: '4px 0', borderColor: 'black', borderTopWidth: '1px' }} />
                    </td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };
  return (
    <nav className={`navbar navbar-expand-lg sticky-nav ${styles.stickyNav} borderBottom`}>
      <div className="container-fluid">

        {isLoading && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0,0,0,0.1)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000,
            }}
          >
            <UploadLoadingIcon />
          </div>
        )}


        <div
          id="adminChartContainer"
          style={{
            width: "400px",
            height: "400px",
            position: "absolute",
            left: "-9999px", // Hides off-screen but still renders
          }}
        >
          <canvas ref={chartRefpdf} id="hiddenAdminChart" />

          <canvas
            id="hiddenExportChart"
            width={600}
            height={400}
            style={{ display: 'none' }}
          ></canvas>
        </div>
        <ul className="d-flex gap-3 list-unstyled mb-0">
          <li>
            <a className={`${styles.navLink} ${styles.navLinkDefault} ${currentPath === '/gapsyAdashboard' ? styles.active : ''}`}
              style={{ cursor: "pointer" }} onClick={handleDashboard}>
              <i className="bi bi-display"></i> Home
            </a>
          </li>

          <li className="dropdown">
            <a className={`dropdown-toggle ${styles.navLink} ${styles.navLinkDefault} ${styles.dropdownToggle}
       ${isTemplateActive ? styles.active : ''}`} href="#" data-bs-toggle="dropdown">
              <i className="bi bi-file-earmark-plus"></i> Template Creation
            </a>
            <ul className={`dropdown-menu mt-2 rounded-0 ${styles.dropdownMenu} ${styles.dropdownMenuStyled}`}>
              <li>
                <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleFbc} style={{ cursor: "pointer" }}>
                  <i className="bi bi-file-code"></i> 1.1 File Based Creation
                </a>
              </li>
              <li>
                <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleIbm} style={{ cursor: "pointer" }}>
                  <i className="bi bi-grid"></i> 1.2 Interactive Builder
                </a>
              </li>
              <li>
                <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleDashboardAI} style={{ cursor: "pointer" }}>
                  <i className="bi bi-chat-dots"></i> 1.3 Interactive Builder (AI)
                </a>
              </li>
              <li>
                <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleModiyTemplate} href="#">
                  <i className="bi bi-pencil"></i> 1.4 Modify Existing Template
                </a>
              </li>
            </ul>
          </li>

          <li className={`dropdown ${styles.dropdown}`}>
            <a className={`dropdown-toggle ${styles.navLink} ${styles.navLinkDefault}`}
              href="#" data-bs-toggle="dropdown">
              <i className="bi bi-box"></i> Reports
            </a>
            <ul className={`dropdown-menu mt-2 rounded-0 ${styles.dropdownMenu} ${styles.dropdownMenuStyled}`}>
              {/* Only show Users Summary if user is in IT department */}
              {userDept === 'IT' && (
                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`}
                    role="button" aria-expanded="false"
                    onClick={generateDoughnutChart}>
                    <i className="bi bi-file-richtext"></i> Audit Report - Users Summary
                  </a>
                </li>
              )}

              <li className={`${styles.dropdownSubmenu}`}>
                <a className={`dropdown-item dropdown-toggle ${styles.dropdownItem}`}
                  href="#" role="button" aria-expanded="false">
                  <i className="bi bi-file-richtext"></i> Audit Report - Templates Summary
                </a>
                <ul className={`dropdown-menu rounded-0 ${styles.submenu} ${styles.dropdownMenuStyled}`}>
                  {["Last 30 Days", "Last 7 Days", "All"].map((option) => (
                    <li key={option}>
                      <button
                        className={`dropdown-item  ${styles.dropdownItem}`}

                        onClick={() => handleGenerateAdminReport(option)}>
                        {option}
                      </button>
                    </li>
                  ))}
                </ul>
              </li>

            </ul>

          </li>
          {dept === 'Risk' && userRole?.toLowerCase() === "maker" && (
            <li className={`dropdown ${styles.dropdown}`}>
              <a className={`dropdown-toggle ${styles.navLink} ${styles.navLinkDefault}`}
                href="#" data-bs-toggle="dropdown">
                <i className="bi bi-shield-lock"></i> Pillar 2 Risk
              </a>
              <ul className={`dropdown-menu mt-2 rounded-0 ${styles.dropdownMenu} ${styles.dropdownMenuStyled}`}>
                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleShariah} style={{ cursor: "pointer" }}>
                    <i className="bi bi-input-cursor-text"></i> Shariah
                  </a>
                </li>
                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleResidualOverrideList} style={{ cursor: "pointer" }}>
                    <i className="bi bi-soundwave"></i> Residual Operational Risk
                  </a>
                </li>
              </ul>
            </li>
          )}

          {userId === "10159" && (
            <li className={`dropdown ${styles.dropdown}`}>
              <a className={`dropdown-toggle ${styles.navLink} ${styles.navLinkDefault}`}
                href="#" data-bs-toggle="dropdown">
                <i className="bi bi-shield-lock"></i> Pillar 2 Risk
              </a>
              <ul className={`dropdown-menu mt-2 rounded-0 ${styles.dropdownMenu} ${styles.dropdownMenuStyled}`}>

                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleShariahList} style={{ cursor: "pointer" }}>
                    <i className="bi bi-input-cursor-text"></i> Shariah
                  </a>
                </li>
                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleResidualReinstateList} style={{ cursor: "pointer" }}>
                    <i className="bi bi-soundwave"></i> Residual Operational Risk
                  </a>
                </li>
                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleShariahMapping} style={{ cursor: "pointer" }}>
                    <i className="bi-activity"></i> Shariah Mapping
                  </a>
                </li>
                {canDownloadShariahReport && (
                  <li>
                    <a
                      className={`dropdown-item ${styles.dropdownItem}`}
                      onClick={handleShariahReport}
                      href="#"
                    >
                      <i className="bi bi-graph-up"></i> Shariah Report
                    </a>
                  </li>
                )}

              </ul>
            </li>
          )}

          {userId === "10159" && (
  <li
    className={`dropdown ${styles.dropdown}`}
    onMouseEnter={() => setIsRmaExpanded(true)}
    onMouseLeave={() => setIsRmaExpanded(false)}
  >
    <a
      className={`dropdown-toggle ${styles.navLink} ${styles.navLinkDefault}`}
      href="#"
      data-bs-toggle="dropdown"
      onClick={() => setIsRmaExpanded(prev => !prev)}
    >
      <i className="bi bi-shield-lock"></i>{" "}
      {isRmaExpanded ? "Risk Measurement Attributes" : "RMA"}
    </a>

    <ul className={`dropdown-menu mt-2 rounded-0 ${styles.dropdownMenu} ${styles.dropdownMenuStyled}`}>

      <li>
        <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleList} style={{ cursor: "pointer" }}>
          <i className="bi bi-input-cursor-text"></i> Complaints
        </a>
      </li>

      <li>
        <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleMediaList} style={{ cursor: "pointer" }}>
          <i className="bi bi-soundwave"></i> Media Publicity
        </a>
      </li>

      <li>
        <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleLeadershipList} style={{ cursor: "pointer" }}>
          <i className="bi bi-people"></i> Leadership
        </a>
      </li>

      <li>
        <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleOperationalList} style={{ cursor: "pointer" }}>
          <i className="bi bi-gear"></i> Operational
        </a>
      </li>

      <li>
        <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleComplianceList} style={{ cursor: "pointer" }}>
          <i className="bi bi-clipboard-check"></i> Compliance
        </a>
      </li>

    </ul>
  </li>
)}

          {userId === "10159" && (
            <li className={`dropdown ${styles.dropdown}`}>
              <a
  className={`dropdown-toggle ${styles.navLink} ${styles.navLinkDefault}`}
  href="#"
  data-bs-toggle="dropdown"
  onMouseEnter={() => setIsRmaMappingExpanded(true)}
  onMouseLeave={() => setIsRmaMappingExpanded(false)}
>
  <i className="bi bi-diagram-2"></i>{" "}
  {isRmaMappingExpanded
    ? "Risk Measurement Attributes Mapping"
    : "RMA Mapping"}
</a>
              <ul className={`dropdown-menu mt-2 rounded-0 ${styles.dropdownMenu} ${styles.dropdownMenuStyled}`}>

                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleComplaintList} style={{ cursor: "pointer" }}>
                    <i className="bi-activity"></i> Complaints Mapping
                  </a>
                </li>

                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleMedia} style={{ cursor: "pointer" }}>
                    <i className="bi bi-soundwave"></i> Media Publicity Mapping
                  </a>
                </li>

                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleLeadership} style={{ cursor: "pointer" }}>
                    <i className="bi bi-people"></i> Leadership Mapping
                  </a>
                </li>

                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleOperational} style={{ cursor: "pointer" }}>
                    <i className="bi bi-gear"></i> Operational Mapping
                  </a>
                </li>

                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleCompliance} style={{ cursor: "pointer" }}>
                    <i className="bi bi-clipboard-check"></i> Compliance Mapping
                  </a>
                </li>

                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleNewMapping} style={{ cursor: "pointer" }}>
                    <i className="bi bi-clipboard-check"></i> Custom Mapping
                  </a>
                </li>

                {(() => {
                  const title = localStorage.getItem("excelTitle")?.trim();

                  if (!title) return null;

                  return (
                    <li>
                      <a
                        className={`dropdown-item ${styles.dropdownItem}`}
                        onClick={handleNewReport}
                        style={{ cursor: "pointer" }}
                      >
                        <i className="bi bi-file-earmark-text"></i>{" "}
                        {title} Mapping
                      </a>
                    </li>
                  );
                })()}

              </ul>
            </li>
          )}

          {userId === "10159" && (
            <li className={`dropdown ${styles.dropdown}`}>
              <a
  className={`dropdown-toggle ${styles.navLink} ${styles.navLinkDefault}`}
  href="#"
  data-bs-toggle="dropdown"
  onMouseEnter={() => setIsRmaReportsExpanded(true)}
  onMouseLeave={() => setIsRmaReportsExpanded(false)}
>
  <i className="bi bi-file-earmark-bar-graph"></i>{" "}
  {isRmaReportsExpanded
    ? "Risk Measurement Attributes Reports"
    : "RMA Reports"}
</a>
              <ul className={`dropdown-menu mt-2 rounded-0 ${styles.dropdownMenu} ${styles.dropdownMenuStyled}`}>

                {canDownloadComplaintsReport && (
                  <li>
                    <a
                      className={`dropdown-item ${styles.dropdownItem}`}
                      onClick={handleComplaintsReport}
                      href="#"
                    >
                      <i className="bi bi-graph-up"></i> Complaints Report
                    </a>
                  </li>
                )}
                {canDownloadMediaReport && (
                  <li>
                    <a
                      className={`dropdown-item ${styles.dropdownItem}`}
                      onClick={handleMediaReport}
                      href="#"
                    >
                      <i className="bi bi-soundwave"></i> Media Publicity Report
                    </a>
                  </li>
                )}
                {canDownloadLeadershipReport && (
                  <li>
                    <a
                      className={`dropdown-item ${styles.dropdownItem}`}
                      onClick={handleLeadershipReport}
                      href="#"
                    >
                      <i className="bi bi-people"></i> Leadership Report
                    </a>
                  </li>
                )}
                {canDownloadOperationalReport && (
                  <li>
                    <a
                      className={`dropdown-item ${styles.dropdownItem}`}
                      onClick={handleOperationalReport}
                      href="#"
                    >
                      <i className="bi bi-gear"></i> Operational Report
                    </a>
                  </li>
                )}
                {canDownloadComplianceReport && (
                  <li>
                    <a
                      className={`dropdown-item ${styles.dropdownItem}`}
                      onClick={handleComplianceReport}
                      href="#"
                    >
                      <i className="bi bi-clipboard-check"></i> Compliance Report
                    </a>
                  </li>
                )}
              </ul>
            </li>
          )}



          {/* /* This is for the RAF Usermapping and User Config screen */}
          {dept === 'IT' && (
            <li className="dropdown">

              <a
                className={`dropdown-toggle ${styles.navLink} ${styles.navLinkDefault} ${styles.dropdownToggle}`}
                href="#"
                data-bs-toggle="dropdown"
              >
                <i className="bi bi-file-richtext"></i> RAF Configurations
              </a>

              <ul className={`dropdown-menu mt-2 rounded-0 ${styles.dropdownMenu} ${styles.dropdownMenuStyled}`}>

                <li>
                  <a
                    className={`dropdown-item ${styles.dropdownItem}`}
                    onClick={handleRoleandMap}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="bi bi-file-richtext"></i> RAF - User - Role Mapping
                  </a>
                </li>
                <li>
                  <a
                    className={`dropdown-item ${styles.dropdownItem}`}
                    onClick={handleParameterMap}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="bi bi-file-richtext"></i> RAF - Reports Parameters
                  </a>
                </li>
                {/* <li>
                  <a
                    className={`dropdown-item ${styles.dropdownItem}`}
                    onClick={handleUserMapping}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="bi bi-file-richtext"></i> RAF - User - Role Mapping
                  </a>
                </li> */}

                {/* <li>
                  <a
                    className={`dropdown-item ${styles.dropdownItem}`}
                    onClick={handleUserConfig}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="bi bi-file-richtext"></i> RAF - Reports Parameters
                  </a>
                </li> */}

              </ul>

            </li>
          )}

          {userId === "10034" && (
            <li className={`dropdown ${styles.dropdown}`}>
              <a className={`dropdown-toggle ${styles.navLink} ${styles.navLinkDefault}`}
                href="#" data-bs-toggle="dropdown">
                <i className="bi bi-shield-lock"></i> Pillar 2 Risk
              </a>
              <ul className={`dropdown-menu mt-2 rounded-0 ${styles.dropdownMenu} ${styles.dropdownMenuStyled}`}>
                {isShariahRiskUser && (
                  <li>
                    <a
                      className={`dropdown-item ${styles.dropdownItem}`}
                      onClick={handleShariahOverrideList}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="bi bi-input-cursor-text"></i>
                      Shariah
                    </a>
                  </li>
                )}
                {isResidualRiskUser && (
                  <li>
                    <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleResidualOverrideList} style={{ cursor: "pointer" }}>
                      <i className="bi bi-soundwave"></i> Residual Operational Risk
                    </a>
                  </li>
                )}
                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleShariahConfiguration} style={{ cursor: "pointer" }}>
                    <i className="bi bi-gear"></i> Configuration
                  </a>
                </li>
                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleResidualORisk} style={{ cursor: "pointer" }}>
                    <i className="bi bi-diagram-3"></i> Workflow Configuration
                  </a>
                </li>
              </ul>
            </li>
          )}

          {userId === "10034" && (
            <li className={`dropdown ${styles.dropdown}`}>
              <a
  className={`dropdown-toggle ${styles.navLink} ${styles.navLinkDefault}`}
  href="#"
  data-bs-toggle="dropdown"
  onMouseEnter={() => setIsRmaExpanded(true)}
  onMouseLeave={() => setIsRmaExpanded(false)}
>
  <i className="bi bi-shield-lock"></i>{" "}
  {isRmaExpanded ? "Risk Measurement Attributes" : "RMA"}
</a>
              <ul className={`dropdown-menu mt-2 rounded-0 ${styles.dropdownMenu} ${styles.dropdownMenuStyled}`}>
                {isCustomerComplaintsUser && (
                  <li>
                    <a
                      className={`dropdown-item ${styles.dropdownItem}`}
                      onClick={handleComplaintOverrideList}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="bi bi-input-cursor-text"></i>
                      Complaint
                    </a>
                  </li>
                )}
                {isMediaUser && (
                  <li>
                    <a
                      className={`dropdown-item ${styles.dropdownItem}`}
                      onClick={handleMediaOverrideList}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="bi bi-soundwave"></i>
                      Media Publicity
                    </a>
                  </li>
                )}
                {isLeadershipUser && (
                  <li>
                    <a
                      className={`dropdown-item ${styles.dropdownItem}`}
                      onClick={handleLeadershipOverrideList}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="bi bi-people"></i>
                      Leadership
                    </a>
                  </li>
                )}
                {isOperationalUser && (
                  <li>
                    <a
                      className={`dropdown-item ${styles.dropdownItem}`}
                      onClick={handleOperationalOverrideList}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="bi bi-gear"></i>
                      Operational
                    </a>
                  </li>
                )}
                {isComplianceUser && (
                  <li>
                    <a
                      className={`dropdown-item ${styles.dropdownItem}`}
                      onClick={handleComplianceOverrideList}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="bi bi-clipboard-check"></i>
                      Compliance
                    </a>
                  </li>
                )}
                {/* {isResidualRiskUser && (
                  <li>
                    <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleResidualOverrideList} style={{ cursor: "pointer" }}>
                      <i className="bi bi-soundwave"></i> Residual Operational Risk
                    </a>
                  </li>
                )}
                  */}
                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleComplaintsConfiguration} style={{ cursor: "pointer" }}>
                    <i className="bi bi-gear"></i> Configuration
                  </a>
                </li>
                <li>
                  <a className={`dropdown-item ${styles.dropdownItem}`} onClick={handleComplaintsRisk} style={{ cursor: "pointer" }}>
                    <i className="bi bi-diagram-3"></i> Workflow Configuration
                  </a>
                </li>
              </ul>
            </li>
          )}

        </ul>
      </div>
      <Modal
        show={!!modalMessage}
        onHide={handleCloseModal}
        backdrop="static"
        keyboard={false}
        style={{ marginTop: '12vh' }}
      >
        <div
          className={`alert alert-${messageType === 'success' ? 'success' : messageType === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`}
          role="alert"
          style={{ marginBottom: '0' }}
        >
          <div className="d-flex align-items-center">
            {messageType === 'success' ? (
              <span className="me-2" style={{ color: 'green', fontSize: '14px' }}>✅</span>
            ) : messageType === 'warning' ? (
              <span className="me-2" style={{ color: '#ffc107', fontSize: '14px' }}>⚠️</span>
            ) : (
              <span className="me-2" style={{ color: 'red', fontSize: '14px' }}>❌</span>
            )}
            <p
              style={{
                display: 'inline',
                marginBottom: '0px',
                color: messageType === 'success'
                  ? 'green'
                  : messageType === 'warning'
                    ? '#ffc107'
                    : 'red'
              }}
            >
              {modalMessage}
            </p>
          </div>
          <button
            type="button"
            className="btn-close"
            onClick={handleCloseModal}
            style={{
              width: '15px',
              height: '15px',
              fontSize: '8px',
              position: 'absolute',
              bottom: '10px',
              right: '10px'
            }}
          />
        </div>
      </Modal>
    </nav>
  );
};

export default Navigation;
